"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const actionTypes_1 = require("./actionTypes");
const actionTypes_2 = require("../documentCache/actionTypes");
const friendlyError_1 = require("../friendlyError");
const makeThunktankAction = (apiPromise) => {
    const defaultPreCacheTransform = (doc) => [doc];
    const config = {
        shouldCache: false,
        cacheAction: null,
        cache: null,
        partial: undefined,
        cacheTransform: defaultPreCacheTransform,
        shouldProvideStore: false,
        errorConfig: {},
    };
    const action = (tankSlice, thunkIndex) => (...params) => ((dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
        const promiseFn = config.shouldProvideStore
            ? apiPromise(dispatch, getState)
            : apiPromise;
        const promiseResult = yield promiseFn(...params).catch((error) => {
            dispatch({
                type: actionTypes_1.THUNKTANK_SET_ERROR,
                slice: tankSlice,
                thunkIndex,
                error: (0, friendlyError_1.getFriendlyError)(error, config.errorConfig),
            });
            console.warn(error);
            console.warn(`The above error was caught and handled in a thunktank action.\n\tredux slice: ${tankSlice}\n\tredux thunkIndex: ${thunkIndex}\n\taction: ${apiPromise}`);
        });
        if (!promiseResult)
            return;
        dispatch({
            type: actionTypes_1.THUNKTANK_SET_DATA,
            slice: tankSlice,
            thunkIndex,
            data: promiseResult,
        });
        if (config.shouldCache && config.cacheTransform) {
            dispatch({
                type: config.cacheAction,
                slice: config.cache,
                docs: config.cacheTransform(promiseResult),
                isPartial: config.partial,
            });
        }
    }));
    action.withCache = (CACHE_NAME, transform = defaultPreCacheTransform) => {
        config.shouldCache = true;
        config.cacheAction = actionTypes_2.CACHE_DOCUMENTS;
        config.cache = CACHE_NAME;
        config.partial = false;
        config.cacheTransform = transform;
        return action;
    };
    action.withPartialCache = (CACHE_NAME, transform = defaultPreCacheTransform) => {
        config.shouldCache = true;
        config.cacheAction = actionTypes_2.CACHE_DOCUMENTS;
        config.cache = CACHE_NAME;
        config.partial = true;
        config.cacheTransform = transform;
        return action;
    };
    action.withUncache = (CACHE_NAME, transform = defaultPreCacheTransform) => {
        config.shouldCache = true;
        config.cacheAction = actionTypes_2.UNCACHE_DOCUMENTS;
        config.cache = CACHE_NAME;
        config.cacheTransform = transform;
        return action;
    };
    action.withStore = () => {
        config.shouldProvideStore = true;
        return action;
    };
    action.withErrors = (errorConfig) => {
        config.errorConfig = errorConfig;
        return action;
    };
    return action;
};
exports.default = makeThunktankAction;
